/**
 * What each module is called — the words on the nav strip and on the portal tiles.
 *
 * ONE DICTIONARY FOR BOTH SURFACES, keyed by MODULE ID. The two registries
 * (shared/constants/modules.js `NAV_MODULES` and routes/Portal.jsx `ALL_MODULES`) already disagree in
 * English — "HR" on the strip, "HR Management" on the tile — and translating each surface where it
 * stands would have carried that into Spanish twice and then let the two drift. Keying off the id
 * means a module is named once. The two lengths that genuinely differ keep a `*Short` entry for the
 * cramped horizontal strip.
 *
 * ⚠ CALL SITES USE `t(m.id) || m.label`, NEVER a bare `t(m.id)`. A module added to a registry without
 * an entry here is absent from the BASE dictionary too, and `makeT` answers '' for that — a BLANK NAV
 * BUTTON, which is exactly the output this whole design forbids. Falling through to the registry's own
 * English label makes a forgotten entry degrade to English like everything else.
 */
export default {
  identity: 'My Profile',
  timekeeping: 'Timekeeping',
  projects: 'Projects',
  crm: 'CRM',
  hr: 'HR Management',
  hrShort: 'HR',
  bidworkup: 'Bid Workup',
  bid_request: 'Bid Request',
  finance: 'Finance & Accounting',
  financeShort: 'Finance',
  documents: 'Document Control',
  documentsShort: 'Documents',
  fleet: 'Fleet Management',
  fleetShort: 'Fleet',
  inventory: 'Inventory',
  officeboard: 'Office Board',
  pdfreader: 'PDF Reader',
  forms: 'Forms',
  capital: 'Capital Projects',
  // The RUNNING project's money — WIP, cost against the forecast, change orders, billing, cash
  // flow, risk, closeout. Was "Job Financials" until 2.99.24; renamed at the owner's direction so
  // the module speaks the same word as the Projects module it now reads from.
  capex: 'Project Financials',
  // The billing documents themselves — pay applications, T&M invoices, receivables, waivers.
  invoicing: 'Invoicing',
  // The AI Office Worker (design change H2) - a separate product the tab hands the person over to.
  office_worker: 'Office Worker',
  compliance: 'Compliance',
  procurement: 'Procurement',
}
